import * as Yup from 'yup'

export default Yup.object({
  email: Yup.string()
    .required('入力必須です。')
    .matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
      'フォーマットが違います。'
    ),
  name: Yup.string().required('入力必須です。').max(50, '50文字以下で入力してください。'),
  group: Yup.string().required('入力必須です。'),
})
